<script lang="ts">
  import PageHeader from '../../lib/components/PageHeader.svelte';
  import { automatic, setAllUnits, setUnit, unitsChoice } from '../../lib/stores/units.svelte';
  import { MEASURES, UNIT_CHOICES, UNIT_NAMES, type Measure, type Units } from '../../lib/utils/units';
  import { setThemeChoice, themeChoice, type ThemeChoice } from '../../lib/stores/theme';
  import { t } from '../../lib/i18n/index.ts';

  // Appearance holds the theme and units this browser keeps (spec 010 FR-034, 010 FR-035).
  const themes: { value: ThemeChoice; label: string }[] = [
    { value: 'system', label: t('settingsThemeSystem') },
    { value: 'light', label: t('settingsThemeLight') },
    { value: 'dark', label: t('settingsThemeDark') },
  ];
  const MEASURE_NAMES: Record<Measure, string> = {
    distance: t('settingsMeasureDistance'), elevation: t('settingsMeasureElevation'), weight: t('settingsMeasureWeight'),
    height: t('settingsMeasureHeight'), temperature: t('settingsMeasureTemperature'),
  };
  // pickUnit sets a measure from its picker, whose empty value is Automatic.
  function pickUnit(m: Measure, value: string) {
    setUnit(m, value ? (value as Units[Measure]) : null);
  }
</script>

<div class="card p-5 mb-6">
  <PageHeader title={t('settingsAppearance')} level="section" />
  <p class="text-sm text-text-muted mb-3">{t('settingsAppearanceNote')}</p>
  <div class="flex gap-2" role="radiogroup" aria-label={t('settingsTheme')}>
    {#each themes as th (th.value)}
      <button type="button" role="radio" aria-checked={$themeChoice === th.value}
              class="btn btn-sm {$themeChoice === th.value ? 'btn-primary' : 'btn-secondary'}"
              onclick={() => setThemeChoice(th.value)}>{th.label}</button>
    {/each}
  </div>
</div>

<div class="card p-5 mb-6">
  <PageHeader title={t('settingsUnits')} level="section">
    <div class="flex gap-2">
      <button type="button" class="btn btn-secondary btn-sm" onclick={() => setAllUnits('metric')}>{t('settingsMetric')}</button>
      <button type="button" class="btn btn-secondary btn-sm" onclick={() => setAllUnits('imperial')}>{t('settingsImperial')}</button>
    </div>
  </PageHeader>
  <p class="text-sm text-text-muted mb-3">{t('settingsUnitsNote')}</p>
  <div class="flex flex-wrap gap-3">
    {#each MEASURES as m (m)}
      <label class="text-sm">
        <span class="block mb-1">{MEASURE_NAMES[m]}</span>
        <select class="input" value={unitsChoice()[m] ?? ''} onchange={(e) => pickUnit(m, e.currentTarget.value)}>
          <option value="">{t('settingsUnitAutomatic', { unit: UNIT_NAMES[automatic[m]] })}</option>
          {#each UNIT_CHOICES[m] as u (u)}
            <option value={u}>{UNIT_NAMES[u]}</option>
          {/each}
        </select>
      </label>
    {/each}
  </div>
</div>
